import axios from "axios";
import { REFUNDS_API_URL } from "../../../constants";
import { getUserToken } from "../../../helpers/Auth";
export const ACTIONS = {
    GET_REFUNDS_LOADING: "GET_REFUNDS_LOADING",
    GET_REFUNDS_SUCCESS: "GET_REFUNDS_SUCCESS",
    GET_REFUNDS_ERROR: "GET_REFUNDS_ERROR",
};

const getRefunds = () => {
    return async (dispatch) => {
        try {
            dispatch({
                type: ACTIONS.GET_REFUNDS_LOADING,
            });

            const res = await axios.get(`${REFUNDS_API_URL}/refund/getall`, {
                headers: {
                    Authorization: `Bearer ${getUserToken()}`,
                },
            });
            if (res.status === 200) {
                dispatch({
                    type: ACTIONS.GET_REFUNDS_SUCCESS,
                    payload: res.data,
                });
            }
        } catch (error) {
            dispatch({
                type: ACTIONS.GET_REFUNDS_ERROR,
                payload: error.message,
            });
        }
    };
};

export default getRefunds;
